export default __webpack_public_path__ + "static/media/line_skin.234da94e.png";